import React from "react"
import { MessageBusType } from "smartstream-widgets/types/sharedModule/core"

type PrebidProps = {
  messageBus: MessageBusType,
  config: {
    fallbackAdMessageName: string,
    adMessageName: string
    advertOptions: {
      slotId: string
    },
    fallbackWidget: {
      path: string,
      message: string
    },
    monetization: {
      defaultAdStrategy: {
        renderAsyncMessage: string
      }
    },
    usePrebid: boolean
  }
}

type PrebidState = {
  widgetData: Array<{}>,
  advertPadding: number
}

type PrebidComponent = React.Component<PrebidProps, PrebidState> & {
  noAdvertCallback?: Function
}

type PrebidEventMsg = {
  body: {
    adUnitCodesInResponse: Array<string>
  }
}

export function fallbackChecker (this: PrebidComponent) {
  const {
    messageBus,
    config: { fallbackAdMessageName = 'observer:fallback' } = {}
  } = this.props

  messageBus && messageBus.addEventListener(fallbackAdMessageName, () => {
    const {
      messageBus,
      config: {
        adMessageName = '',
        advertOptions = {} as { slotId: string },
        fallbackWidget: {
          path: fallbackWidgetPath = '',
          message: fallbackWidgetMessage = 'fallbackWidget:render'
        } = {},
        monetization: {
          defaultAdStrategy: {
            renderAsyncMessage = 'asyncadvert'
          } = {}
        } = {},
        usePrebid = false
      } = {}
    } = this.props

    const { advertPadding, widgetData } = this.state

    const hasData = widgetData && widgetData.length > 0

    const sendFallbackMessage = () => {
      messageBus.dispatchEvent(adMessageName, {
        ...advertOptions,
        isFallback: true
      })
    }

    if (!hasData) {
      messageBus.dispatchEvent('poisonpill')
      if (fallbackWidgetPath) {
        messageBus.dispatchEvent(fallbackWidgetMessage)
      } else if (adMessageName && advertOptions) {
        if (usePrebid) {
          messageBus.addEventListener('prebid:ready', (event: PrebidEventMsg) => {
            const { body: { adUnitCodesInResponse = [] } = {} } = event
            if (adUnitCodesInResponse.includes(advertOptions.slotId)) {
              sendFallbackMessage()
            }
          })
          messageBus.dispatchEvent('prebid:request', { adUnitCodes: [advertOptions.slotId] })
        } else {
          sendFallbackMessage()
        }
      }
    } else if (hasData) {
      messageBus.dispatchEvent('widget:hasdata')
      if (usePrebid && advertPadding) {
        const slotId = 'slot-container'
        messageBus.addEventListener('prebid:ready', (event: PrebidEventMsg) => {
          const { body: { adUnitCodesInResponse = [] } = {} } = event
          if (adUnitCodesInResponse.includes(slotId)) {
            messageBus.dispatchEvent(`${renderAsyncMessage}:render`)
          } else {
            if (this.noAdvertCallback && typeof this.noAdvertCallback === 'function') {
              this.noAdvertCallback()
            } else {
              this.setState({ advertPadding: 0 })
            }
          }
        })
        messageBus.dispatchEvent('prebid:request', { adUnitCodes: [slotId] })
      }
    }
  })
}
